/**
 * Auction PLP/PDP: small eager half of the RA header search (TWS-1368).
 *
 * ra-search.js (autocomplete) is heavy to parse + init, so it is only injected when the
 * shopper engages the header search box (pointerdown/touchstart/focus). Everything that
 * must be in place before that stays here:
 *  - Prefixbox autocomplete / preloader suppression (Prefixbox Integration is released on
 *    first interaction, long before any search focus).
 *  - Header input prefill from ?q= (collection templates have no search.terms).
 * Submit/Enter and Location merch guards are inline in theme.liquid.
 */
(function () {
  'use strict';

  if (!document.body || document.body.dataset.storefrontSearchScope !== 'auction') return;

  var INPUT_SEL = '.global-header__search [data-search-input]';
  var scriptEl = document.currentScript;
  var raSearchSrc = scriptEl && scriptEl.getAttribute('data-ra-search-src');

  /**
   * Prefixbox Integration binds autocomplete to inputs named `q` and can still open
   * on auction-tagged PDPs (path not in Prefixbox LoadCondition). Keep name=ra_q and
   * tear down any Prefixbox autocomplete / stuck preloader DOM that appears.
   * After B1 LoadCondition excludes auction pages, Integration may still inject
   * `.pfbx-preloader` then abort — remove it so the RA PLP is usable.
   */
  function suppressPrefixboxAutocomplete() {
    var PREFIXBOX_AC_SEL = [
      '.prefixbox-autocomplete-container',
      '#pfbx-ac-blur-overlay',
      '.pfbx-ac-blur-overlay',
      '.pfbx-ac-desktop',
      '.pfbx-ac-mobile',
    ].join(',');
    var PREFIXBOX_PRELOADER_SEL = [
      '.pfbx-preloader',
      '#pfbx-preloader',
      '[class*="pfbx-preloader"]',
      '[id*="pfbx-preloader"]',
      '.prefixbox-preloader',
      '#prefixbox-preloader',
    ].join(',');
    var PREFIXBOX_SUPPRESS_SEL = PREFIXBOX_AC_SEL + ',' + PREFIXBOX_PRELOADER_SEL;

    function isPreloaderNode(el) {
      if (!el || el.nodeType !== 1) return false;
      if (el.matches && el.matches(PREFIXBOX_PRELOADER_SEL)) return true;
      var id = (el.id || '').toLowerCase();
      var cls = typeof el.className === 'string' ? el.className.toLowerCase() : '';
      return id.indexOf('pfbx-preloader') !== -1 || cls.indexOf('pfbx-preloader') !== -1;
    }

    function hideOrRemoveNodes(root) {
      var scope = root && root.querySelectorAll ? root : document;
      var nodes = scope.querySelectorAll
        ? scope.querySelectorAll(PREFIXBOX_SUPPRESS_SEL)
        : [];
      for (var i = 0; i < nodes.length; i++) {
        var el = nodes[i];
        if (isPreloaderNode(el)) {
          if (el.parentNode) el.parentNode.removeChild(el);
          continue;
        }
        el.setAttribute('hidden', '');
        el.style.setProperty('display', 'none', 'important');
        el.style.setProperty('visibility', 'hidden', 'important');
        el.style.setProperty('pointer-events', 'none', 'important');
      }
      // If `root` itself matches a Prefixbox node
      if (root && root.nodeType === 1 && root.matches && root.matches(PREFIXBOX_SUPPRESS_SEL)) {
        if (isPreloaderNode(root)) {
          if (root.parentNode) root.parentNode.removeChild(root);
        } else {
          root.setAttribute('hidden', '');
          root.style.setProperty('display', 'none', 'important');
        }
      }
    }

    hideOrRemoveNodes(document);

    var headerInput =
      document.querySelector('.global-header__search [data-ra-search-input]') ||
      document.querySelector(INPUT_SEL);
    if (headerInput && headerInput.name === 'q') {
      headerInput.name = 'ra_q';
      headerInput.setAttribute('data-ra-search-input', '');
    }

    if (typeof MutationObserver === 'undefined') return;
    var observer = new MutationObserver(function (mutations) {
      for (var m = 0; m < mutations.length; m++) {
        var added = mutations[m].addedNodes;
        for (var n = 0; n < added.length; n++) {
          var node = added[n];
          if (node.nodeType !== 1) continue;
          hideOrRemoveNodes(node);
        }
      }
    });
    observer.observe(document.documentElement, { childList: true, subtree: true });
  }

  var raSearchRequested = false;
  function loadRaSearch() {
    if (raSearchRequested || !raSearchSrc) return;
    raSearchRequested = true;
    var s = document.createElement('script');
    s.src = raSearchSrc;
    s.async = true;
    document.head.appendChild(s);
  }

  function isHeaderSearchInput(t) {
    return !!(t && t.nodeType === 1 && t.matches && t.matches(INPUT_SEL));
  }

  function onEngage(e) {
    if (!isHeaderSearchInput(e.target)) return;
    loadRaSearch();
    document.removeEventListener('focusin', onEngage, true);
    document.removeEventListener('pointerdown', onEngage, true);
    document.removeEventListener('touchstart', onEngage, true);
  }

  // pointerdown/touchstart start the fetch a beat before focus lands on tap.
  document.addEventListener('focusin', onEngage, true);
  document.addEventListener('pointerdown', onEngage, { capture: true, passive: true });
  document.addEventListener('touchstart', onEngage, { capture: true, passive: true });

  function init() {
    suppressPrefixboxAutocomplete();

    var headerInput = document.querySelector(INPUT_SEL);
    if (!headerInput) return;
    var q = new URLSearchParams(window.location.search).get('q') || '';
    if (q && !headerInput.value) headerInput.value = q;
    // Focused before this deferred script ran (fast tap / autofocus).
    if (document.activeElement === headerInput) loadRaSearch();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
